import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import SignaturePage from "@/pages/SignaturePage";
import BeratungPflegeassistenz from "@/pages/BeratungPflegeassistenz";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import AGB from "@/pages/AGB";
import BuchungErfolg from "@/pages/BuchungErfolg";
import BuchungAbbruch from "@/pages/BuchungAbbruch";
import Shop from "@/pages/Shop";
import EbookProduct from "@/pages/EbookProduct";
import EbookDownload from "@/pages/EbookDownload";
import CourseLanding from "@/pages/CourseLanding";
import Kurse from "@/pages/Kurse";
import Services from "@/pages/Services";
import Barrierefreiheit from "@/pages/Barrierefreiheit";
import PflegeKiFuehrerschein from "@/pages/PflegeKiFuehrerschein";
import PflegekraftLanding from "@/pages/PflegekraftLanding";
import PflegedienstLanding from "@/pages/PflegedienstLanding";
import CampusPage from "@/pages/CampusPage";
import CampusProPage from "@/pages/CampusProPage";
import CampusTeamPage from "@/pages/CampusTeamPage";
import Preise from "@/pages/Preise";
import AngehoerigenLeitfaden from "@/pages/AngehoerigenLeitfaden";
import LeitfadenLanding from "@/pages/LeitfadenLanding";
import Leitfaeden from "@/pages/Leitfaeden";
import Pflichtfortbildungen from "@/pages/Pflichtfortbildungen";
import Leitbild from "@/pages/Leitbild";
import CookieBanner from "@/components/site/CookieBanner";
import { RefDiscountBanner } from "@/components/site/RefDiscountBanner";
import { FloatingConsultButton } from "@/components/site/FloatingConsultButton";
import MobileStickyCTA from "@/components/site/MobileStickyCTA";
import { IosInstallHint } from "@/components/site/PwaInstall";
import { useLocation } from "react-router-dom";

// Campus Member Area (Demo-Mode)
import { CampusAuthProvider } from "@/contexts/CampusAuth";
import CampusProtectedRoute from "@/components/campus/CampusProtectedRoute";
import CampusLogin from "@/pages/CampusLogin";
import VerifyEmail from "@/pages/VerifyEmail";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import CampusLayout from "@/pages/campus/CampusLayout";
import CampusDashboard from "@/pages/campus/CampusDashboard";
import CampusSchatzkiste from "@/pages/campus/CampusSchatzkiste";
import CampusLagezentrum from "@/pages/campus/CampusLagezentrum";
import CampusBriefings from "@/pages/campus/CampusBriefings";
import CampusProfil from "@/pages/campus/CampusProfil";
import CampusJobs from "@/pages/campus/CampusJobs";
import CampusTalents from "@/pages/campus/CampusTalents";
import CampusBuchungen from "@/pages/campus/CampusBuchungen";
import CampusReminderStats from "@/pages/campus/CampusReminderStats";
import CampusBundeslandStats from "@/pages/campus/CampusBundeslandStats";
import CampusLeadsInbox from "@/pages/campus/CampusLeadsInbox";
import CampusPflegeKi from "@/pages/campus/CampusPflegeKi";
import CampusPflegeKiKb from "@/pages/campus/CampusPflegeKiKb";
import CampusPflegeKiAdmin from "@/pages/campus/CampusPflegeKiAdmin";
import CampusPflegeKiLernsystem from "@/pages/campus/CampusPflegeKiLernsystem";
import PatientenmappeList from "@/pages/campus/PatientenmappeList";
import PatientenmappeDetail from "@/pages/campus/PatientenmappeDetail";
import QprLexikon from "@/pages/campus/QprLexikon";
import Fortbildungsplan from "@/pages/campus/Fortbildungsplan";
import AnzeigeAmbulanterPflegeassistent from "@/pages/AnzeigeAmbulanterPflegeassistent";
import AnzeigePdl from "@/pages/AnzeigePdl";
import DesignPreview from "@/pages/DesignPreview";
import AnzeigeExternenpruefung from "@/pages/AnzeigeExternenpruefung";
import RecruitingClip from "@/pages/campus/RecruitingClip";
import AdminUserImport from "@/pages/campus/AdminUserImport";
import AdminUserManagement from "@/pages/campus/AdminUserManagement";
import AdminLeadStatistik from "@/pages/campus/AdminLeadStatistik";
import BuchRedirect from "@/pages/BuchRedirect";
import CreatorStats from "@/pages/CreatorStats";
import AdminOutreach from "@/pages/campus/AdminOutreach";
import PflegeKiTesten, { PflegeKiTestenErfolg } from "@/pages/PflegeKiTesten";
import LeadmagnetConfirmed from "@/pages/LeadmagnetConfirmed";
import AdminSocialImageGenerator from "@/pages/campus/AdminSocialImageGenerator";
import AdminKiUsage from "@/pages/campus/AdminKiUsage";
import AdminQualitaetsDashboard from "@/pages/campus/AdminQualitaetsDashboard";
import CampusFortbildungen from "@/pages/campus/CampusFortbildungen";
import LpSelbstzahler from "@/pages/lp/LpSelbstzahler";
import LpPflegedienste from "@/pages/lp/LpPflegedienste";
import LpLg1Lg2 from "@/pages/lp/LpLg1Lg2";
import LpPalliativ from "@/pages/lp/LpPalliativ";
import LpWerDarfWas from "@/pages/lp/LpWerDarfWas";
import LpExternenpruefungPfa from "@/pages/lp/LpExternenpruefungPfa";
import AnnouncementBar from "@/components/site/AnnouncementBar";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import AtlasWerDarfWas from "@/pages/AtlasWerDarfWas";
import AzavZulassung from "@/pages/AzavZulassung";
import LpCashBundle from "@/pages/LpCashBundle";
import LpMdSchutzschild from "@/pages/LpMdSchutzschild";
import LpPflegekraftBundle from "@/pages/LpPflegekraftBundle";
import { Navigate } from "react-router-dom";
import { LEGACY_REDIRECTS, ProductRedirect } from "@/redirects";
import ScrollManager from "@/components/ScrollManager";
import PageViewTracker from "@/components/PageViewTracker";

function App() {
  return (
    <div className="App grain-overlay">
      <CampusAuthProvider>
        <BrowserRouter>
          <a
            href="#inhalt"
            className="skip-link"
            data-testid="skip-link"
            onClick={(e) => {
              const main = document.getElementById("inhalt") || document.querySelector("main");
              if (main) {
                e.preventDefault();
                main.setAttribute("tabindex", "-1");
                main.focus({ preventScroll: false });
                main.scrollIntoView();
              }
            }}
          >
            Zum Inhalt springen
          </a>
          <ScrollManager />
          <PageViewTracker />
          <AnnouncementBarWrapper />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/buch" element={<BuchRedirect />} />
            <Route path="/celina" element={<Navigate to="/?ref=Celina10" replace />} />
            <Route path="/creator-statistik/:code" element={<CreatorStats />} />
            <Route path="/unterschrift/:token" element={<SignaturePage />} />
            <Route path="/beratung-pflegeassistenz" element={<BeratungPflegeassistenz />} />
            <Route path="/atlas-wer-darf-was" element={<AtlasWerDarfWas />} />
            <Route path="/azav-zulassung" element={<AzavZulassung />} />
            <Route path="/leitbild" element={<Leitbild />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/barrierefreiheit" element={<Barrierefreiheit />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/agb" element={<AGB />} />
            <Route path="/buchung/erfolg" element={<BuchungErfolg />} />
            <Route path="/buchung/abbruch" element={<BuchungAbbruch />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/shop/download/:sessionId" element={<EbookDownload />} />
            <Route path="/shop/:ebookId" element={<EbookProduct />} />
            <Route path="/pflege-ki-fuehrerschein" element={<PflegeKiFuehrerschein />} />
            <Route path="/kurse" element={<Kurse />} />
            <Route path="/services" element={<Services />} />
            <Route path="/kurse/pflege-ki-fuehrerschein" element={<Navigate to="/pflege-ki-fuehrerschein" replace />} />
            <Route path="/kurse/:slug" element={<CourseLanding />} />
            <Route path="/pflegekraefte" element={<PflegekraftLanding />} />
            <Route path="/pflegedienste" element={<PflegedienstLanding />} />
            <Route path="/weiterbildung-pflege" element={<LpSelbstzahler />} />
            <Route path="/fortbildung-pflegedienste" element={<LpPflegedienste />} />
            <Route path="/lg1-lg2" element={<LpLg1Lg2 />} />
            <Route path="/palliativ" element={<LpPalliativ />} />
            <Route path="/wer-darf-was" element={<LpWerDarfWas />} />
            <Route path="/externenpruefung-pflegefachassistenz" element={<LpExternenpruefungPfa />} />
            <Route path="/anzeige/ambulanter-pflegeassistent" element={<AnzeigeAmbulanterPflegeassistent />} />
            <Route path="/anzeige/pdl" element={<AnzeigePdl />} />
            <Route path="/anzeige/externenpruefung" element={<AnzeigeExternenpruefung />} />
            <Route path="/design-preview" element={<DesignPreview />} />

            {/* Redirects der alten WordPress-URLs (SEO-/Ads-Migration) */}
            {LEGACY_REDIRECTS.map(({ from, to }) => (
              <Route key={from} path={from} element={<Navigate to={to} replace />} />
            ))}
            <Route path="/product/:slug" element={<ProductRedirect />} />
            <Route path="/produkt/:slug" element={<ProductRedirect />} />
            <Route path="/campus" element={<CampusPage />} />
            <Route path="/campus/pro" element={<CampusProPage />} />
            <Route path="/campus/team" element={<CampusTeamPage />} />
            <Route path="/preise" element={<Preise />} />
            <Route path="/pflege-ki-testen" element={<PflegeKiTesten />} />
            <Route path="/pflege-ki-testen/erfolg" element={<PflegeKiTestenErfolg />} />
            <Route path="/leitfaden/angehoerigen-beschwerde" element={<AngehoerigenLeitfaden />} />
            <Route path="/leitfaden/:slug" element={<LeitfadenLanding />} />
            <Route path="/leitfaeden" element={<Leitfaeden />} />
            <Route path="/leitfaeden/cash-bundle" element={<LpCashBundle />} />
            <Route path="/leitfaeden/md-schutzschild" element={<LpMdSchutzschild />} />
            <Route path="/leitfaeden/pflegekraft-bundle" element={<LpPflegekraftBundle />} />
            <Route path="/pflichtfortbildungen" element={<Pflichtfortbildungen />} />
            <Route path="/leadmagnet/bestaetigt" element={<LeadmagnetConfirmed />} />

            {/* Campus Member Area – Demo */}
            <Route path="/campus/login" element={<CampusLogin />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              path="/campus/app"
              element={
                <CampusProtectedRoute>
                  <CampusLayout />
                </CampusProtectedRoute>
              }
            >
              <Route index element={<CampusDashboard />} />
              <Route path="schatzkiste" element={<CampusSchatzkiste />} />
              <Route path="lagezentrum" element={<CampusLagezentrum />} />
              <Route path="briefings" element={<CampusBriefings />} />
              <Route path="jobs" element={<CampusJobs />} />
              <Route path="talents" element={<CampusTalents />} />
              <Route path="fortbildungen" element={<CampusFortbildungen />} />
              <Route path="profil" element={<CampusProfil />} />
              <Route path="buchungen" element={<CampusBuchungen />} />
              <Route path="reminder-stats" element={<CampusReminderStats />} />
              <Route path="bundesland-stats" element={<CampusBundeslandStats />} />
              <Route path="leads-inbox" element={<CampusLeadsInbox />} />
              <Route path="pflege-ki" element={<CampusPflegeKi />} />
              <Route path="pflege-ki/wissensbibliothek" element={<CampusPflegeKiKb />} />
              <Route path="pflege-ki/admin" element={<CampusPflegeKiAdmin />} />
              <Route path="pflege-ki/lernsystem" element={<CampusPflegeKiLernsystem />} />
              <Route path="patientenmappe" element={<PatientenmappeList />} />
              <Route path="patientenmappe/:id" element={<PatientenmappeDetail />} />
              <Route path="qpr-lexikon" element={<QprLexikon />} />
              <Route path="fortbildungsplan" element={<Fortbildungsplan />} />
              <Route path="recruiting-clip" element={<RecruitingClip />} />
              <Route path="admin/user-import" element={<AdminUserImport />} />
              <Route path="admin/users" element={<AdminUserManagement />} />
              <Route path="admin/lead-statistik" element={<AdminLeadStatistik />} />
              <Route path="admin/outreach" element={<AdminOutreach />} />
              <Route path="admin/ki-nutzung" element={<AdminKiUsage />} />
              <Route path="admin/social-image" element={<AdminSocialImageGenerator />} />
              <Route path="admin/qualitaets-dashboard" element={<AdminQualitaetsDashboard />} />
            </Route>
          </Routes>
          <CookieBanner />
          <RefDiscountBanner />
          <FloatingConsultButton />
          <MobileStickyCTAWrapper />
          <IosInstallHint />
        </BrowserRouter>
      </CampusAuthProvider>
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}

export default App;

/**
 * MobileStickyCTAWrapper · Zeigt die Sticky-Bar NUR auf Marketing-Seiten.
 * Ausgeschlossen: Campus-App (/campus/app/*), Login/Auth-Flows, Buchung-Erfolg/Abbruch.
 */
function MobileStickyCTAWrapper() {
  const { pathname } = useLocation();
  const excluded =
    pathname.startsWith("/campus/app") ||
    pathname.startsWith("/campus/login") ||
    pathname.startsWith("/beratung-pflegeassistenz") ||
    pathname.startsWith("/atlas-wer-darf-was") ||
    pathname.startsWith("/unterschrift/") ||
    pathname.startsWith("/verify-email") ||
    pathname.startsWith("/forgot-password") ||
    pathname.startsWith("/reset-password") ||
    pathname.startsWith("/buchung/");
  if (excluded) return null;
  return <MobileStickyCTA />;
}

/**
 * AnnouncementBarWrapper · Marketing-Announcement NUR auf öffentlichen Seiten
 * zeigen — in der eingeloggten Campus-App stört die Bar den Workflow und
 * konkurriert mit der Mobile-TopBar um top-0.
 */
// Jun 2026: wieder aktiv — zeigt nur den Services-Slot (Pflegedienst-Homepage ab 1.990 €).
const SHOW_ANNOUNCEMENT = true;

function AnnouncementBarWrapper() {
  const { pathname } = useLocation();
  if (!SHOW_ANNOUNCEMENT) return null;
  const excluded =
    pathname.startsWith("/campus/app") ||
    pathname.startsWith("/campus/login") ||
    pathname.startsWith("/beratung-pflegeassistenz") ||
    pathname.startsWith("/unterschrift/") ||
    pathname.startsWith("/verify-email") ||
    pathname.startsWith("/forgot-password") ||
    pathname.startsWith("/reset-password");
  if (excluded) return null;
  return <AnnouncementBar />;
}
